export default __webpack_public_path__ + "static/media/245.d94de6c9.png";